import React from 'react';
import * as MyCells from '../../../utils/Cells';
import ActionMenu from '../../common/action/ActionMenu';
import StatusCell from '../../common/cells/StatusCell';
import LinkCell from './LinkCell';
import ProposedCell from './ProposedCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'stateLabel',
            id: 'stateLabel',
            show: true,
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'sorszam idColumn center',
            // headerClassName: 'hhhh',
            // filterHeaderClassName: 'filerr',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Tranzakció azonosító',
            accessor: 'transactionId',
            id: 'transactionId',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Tranzakció típusa',
            accessor: 'simpleTransactionTypeLabel',
            id: 'simpleTransactionTypeLabel',
            show: true,
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: row => (
                // Use Cell to render an expander for each row.
                // We can use the getToggleRowExpandedProps prop-getter
                // to build the expander.
                <>
                    <div className="base-cell-content">
                        {row.value}
                    </div>
                    {row.value !== row.row.original.transactionTypeLabel &&
                        <div className="small-cell-content">
                            {row.row.original.transactionTypeLabel}
                        </div>
                    }

                </>)
        },
        {
            Header: 'Irány',
            accessor: 'transactionSideLabel',
            id: 'transactionSideLabel',
            show: true,
            className: 'idColumn center',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
        },
        {
            Header: 'Tranzakció időpontja',
            accessor: 'transactionDateTime',
            id: 'transactionDateTime',
            show: true,
            className: 'dateTimeColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateTimeCell value={props.value} />,
        },
        {
            Header: 'Értéknap',
            accessor: 'valueDate',
            id: 'valueDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Összeg',
            accessor: 'amount',
            id: 'amount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Ellenoldali számlaszám',
            accessor: 'contraBankAccountNumber',
            id: 'contraBankAccountNumber',
            show: true,
            className: 'bankAccountNumberColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Ellenoldali név',
            accessor: 'contraName',
            id: 'contraName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Közlemény',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Javasolt',
            id: 'proposedObject',
            Cell: value => <ProposedCell row={value.row.original} />,
            show: false,
        },
        {
            Header: 'Linkelt',
            id: 'linkedObjects',
            Cell: value => <LinkCell row={value.row.original} />,
            show: false,
        },
        {
            Header: 'Linkelt Partner',
            id: 'linkedPartnerName',
            accessor: 'linkedPartnerName',
            show: false,
            Filter: TextColumnFilter,
        },
        {
            Header: () => null, // No header
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Cell: value => <ActionMenu row={value.row.original} tabletype={'bank'} refresh={refresh} />,
        },
    ]
}